<template>
  <section>
    <b-container>
      <div class="learning-path">
        <div class="title">
          <div class="border-vertical"></div>
          <div>
            <h4>Ready To Choose Your Learning Path?</h4>
          </div>
        </div>
        <b-row no-gutters>
          <b-col cols="4">
            <div class="card-wrapper">
              <LearningPathCard />
            </div>
          </b-col>
          <b-col cols="4">
            <div class="card-wrapper">
              <LearningPathCard />
            </div>
          </b-col>
          <b-col cols="4">
            <div class="card-wrapper mr-0~">
              <LearningPathCard />
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </section>
</template>

<script>
import LearningPathCard from "@/components/home/LearningPathCard";
export default {
  name: "LearningPath",
  components: { LearningPathCard },
};
</script>

<style lang="scss" scoped>
section {
  background-color: #f1bc04;
  padding: 95px 0;

  .container {
    max-width: 1174px;
  }
}
.learning-path {
  .title {
    margin-bottom: 55px;
    display: flex;
    justify-content: flex-start;
    gap: 12px;

    .border-vertical {
      background: #024089;
      width: 3px;
      height: 25px;
      top: 8px;
      position: relative;
    }
    h4 {
      color: #000000;
      font-size: 35px;
      line-height: 41px;
      letter-spacing: 0.05em;
    }
  }

  .card-wrapper {
    margin-right: 14px;
  }
}
</style>
